import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorksSection() {
  const steps = [{
    num: '1',
    title: 'Activa',
    desc: 'Desbloqueas tus filtros linfáticos principales con el bombeo rítmico.'
  }, {
    num: '2',
    title: 'Esculpe',
    desc: 'Sigues las 5 maniobras brasileñas para empujar el líquido hacia las salidas.'
  }, {
    num: '3',
    title: 'Elimina',
    desc: 'Bebes el "Shot Post-Drenaje" para que tu cuerpo expulse todo por la orina.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-104">
      <div className="max-w-4xl mx-auto" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-106">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-[#3D2B1F] mb-4" data-id="element-107">
            Cómo funciona el método
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-108">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-0.5 bg-[#C8956C]/30 -z-10" data-id="element-109" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="text-center" data-id="element-110">
              <div className="w-24 h-24 mx-auto bg-[#FDF8F0] border-4 border-[#C8956C] rounded-full flex items-center justify-center text-4xl font-heading font-bold text-[#C8956C] mb-6 shadow-lg" data-id="element-111">
                {step.num}
              </div>
              <h3 className="text-2xl font-bold text-[#3D2B1F] mb-3" data-id="element-112">
                {step.title}
              </h3>
              <p className="text-[#5A4332] leading-relaxed" data-id="element-113">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}